module.exports = __webpack_public_path__ + "img/B251.dd56b8af.png";